import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

const API_BASE = process.env.NEXT_PUBLIC_API_URL ?? "http://api.ucheta.local"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Преобразует относительный путь storage в публичный URL API. */
export function resolveStorageUrl(path: string | null | undefined): string | null {
  if (!path) return null
  if (
    path.startsWith("http://") ||
    path.startsWith("https://") ||
    path.startsWith("data:")
  ) {
    return path
  }
  return `${API_BASE}/storage/${path.replace(/^\//, "")}`
}

/** Копирует текст в буфер обмена (Clipboard API + fallback для HTTP). */
export async function copyTextToClipboard(text: string): Promise<boolean> {
  if (!text || typeof document === "undefined") return false

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
      return true
    }
  } catch {
    // fallback ниже
  }

  try {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "fixed"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()
    const ok = document.execCommand("copy")
    document.body.removeChild(textarea)
    return ok
  } catch {
    return false
  }
}
